import React from "react";
import Photo from "./Photo";

const BodyPhotos = ({ photos, handlePreviewModal }) => {
  return (
    <div>
      {["front", "back", "side"].map((type, i) => {
        return (
          <Photo
            src={photos[type] ? photos[type].s3Path : null}
            className="progress-photo"
            onClickFunction={
              handlePreviewModal
                ? () => handlePreviewModal(type, photos[type].s3Path)
                : null
            }
            key={photos?.[type]?.name || i}
          />
        );
      })}
    </div>
  );
};

export default BodyPhotos;
